<template>
    <div class="card-publish md">
        <div class="card">
            <h3 class="card-publish-title">Publicación</h3>
            <div class="card-publish-big-group">
                <label for="image" class="card-publish-label">Categorías:</label>
                <span class="card-publish-cat" :class="categories.includes(value)?'active':''" v-for="(value, key) in getCategories" :key="key" @click="changeState(value)">
                    <img src="@/assets/icons/plus.svg" alt="Plus icon" class="icon"> {{ value.name }}
                </span>
            </div>
            <div class="card-publish-big-group">
                <label for="title" class="card-publish-label">Sedes:</label>
                <multiselect
                    placeholder="sedes disponibles"
                    track-by="id"
                    label="name"
                    class="publish-store-select"
                    v-model="stores"
                    :hide-selected="true"
                    :options="getStores"
                    :multiple="true">
                    <span class="limit">No puede seleccionar más sedes</span>
                    <span slot="noResult">No hemos encontrado sedes</span>
                    <span slot="noOptions">No hemos encontrado sedes</span>
                </multiselect>
            </div>
            <div class="card-publish-group">
                <label for="title" class="card-publish-label">Fecha Inicio:</label>
                <div class="card-publish-datepicker">
                    <label for="init_date"><i class="fa fa-calendar-alt"></i></label>
                    <datepicker
                        :language="es"
                        :disabled-dates="disabledInitDate"
                        v-model="initDate"
                        :input-class="initDate?'card-publish-input active':'card-publish-input'"
                        id="init_date"
                        placeholder="YYYY-MM-DD"></datepicker>
                </div>
            </div>
            <div class="card-publish-group-column">
                <label for="title" class="card-publish-label">Fecha Termino:</label>
                <div class="card-publish-datepicker">
                    <label for="end_date"><i class="fa fa-calendar-alt"></i></label>
                    <datepicker
                        :language="es"
                        :disabled-dates="disabledEndDate"
                        v-model="endDate"
                        :input-class="endDate?'card-publish-input active':'card-publish-input'"
                        id="end_date"
                        placeholder="YYYY-MM-DD"></datepicker>
                </div>
            </div>
            <button class="btn btn-form-cancel" @click.prevent="$emit('showModal')">
                Cancelar
            </button>
            <button class="btn btn-publish" :class="okForm ? 'active' : ''" :disabled="!okForm" @click.prevent="programOffer()">
                Publicar Oferta
            </button>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {es} from 'vuejs-datepicker/dist/locale'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'PublishCard',
    components: {
        Multiselect,
        Datepicker
    },
    data: function(){
        return {
            stores: [],
            es: es,
            categories: [],
            initDate: new Date(),
            endDate: null,
        }
    },
    computed: {
        disabledInitDate: function(){
            return {to: (d => new Date(d.setDate(d.getDate()-1)))(new Date)}
        },
        disabledEndDate: function(){
            return {to: this.initDate}
        },
        okForm: function(){
            if(this.stores.length > 0 && this.categories.length > 0 && this.initDate && this.endDate){
                return true
            }
            return false
        },
        activeCat: function(cat){
            return this.categories.includes(cat)
        },
        offerCategories: function(){
            let categories = ""
            this.categories.forEach(cat => {
                categories = categories + cat.id + ","
            });
            return categories.slice(0, -1)
        },
        offerStores: function(){
            let stores = ""
            this.stores.forEach(store => {
                stores = stores + store.id + ","
            })
            return stores.slice(0, -1)
        },
        ...mapGetters({
            'getStores': 'stores/allStores',
            'getCategories': 'offers/getCategories',
        })
    },
    methods: {
        changeState: function(cat){
            if(this.categories.includes(cat)){
                this.categories = this.categories.filter(item => {return item != cat})
            } else {
                this.categories.push(cat)
            }
        },
        date: function(date){
            return moment(date).format('YYYY-MM-DD');
        },
        programOffer: function(){
            var form = new FormData();
            form.append("category", this.offerCategories);
            form.append("store", this.offerStores);
            form.append("init_date", this.date(this.initDate));
            form.append("end_date", this.date(this.endDate));
            if (moment(this.initDate) <= moment()) {
                form.append("is_active", true);
            }
            this.publishOffer({
                'id': this.$route.params.id,
                'publishData': form})
                .then(r => {
                    this.setEmptyDummyOffer()
                    this.$router.push({path: "/offers"})
                }, err => {
                    console.log(err)
                })
        },
        ...mapActions({
            'publishOffer': 'offers/publishOffer',
            'setEmptyDummyOffer': 'offers/setEmptyDummyOffer'
        })
    }
}
</script>

<style lang="sass">
.card-publish
    width: 100%
.card-publish .card
    width: 100%
    border-radius: 4px
    border: solid 1px #e5edf4
    background-color: #ffffff
    display: grid
    grid-template-columns: 8px 1fr 1fr 8px
    grid-gap: 16px 8px
.card-publish.md
    grid-column-end: span 2
.card-publish-title
    grid-column-start: 2
    margin: 16px 2px
    font-family: Montserrat
    font-size: 20px
    font-weight: 600
    color: #302f2f
.card-publish-big-group
    grid-column-start: 2
    grid-column-end: span 2
    position: relative
    width: 100%
.card-publish-group
    grid-column-start: 2
    width: 100%
.card-publish-group-column
    width: 100%
.card-publish-label
    font-family: Muli
    font-size: 12px
    font-weight: 300
    color: #636363
    display: block
    margin-bottom: 8px
.card-publish-input
    width: 100%
    border: none
    outline: none
    // background: #f0f4f5
    background: #ffffff
    // border-left: 2px solid #b9babb
    padding: 6px 8px
    font-family: Muli
    font-size: 16px
    font-weight: 600
    color: #302f2f
// .card-publish-input.active
    // border-color: $primary
// .card-publish-input.disabled
//     width: 100%
//     border-left: none
.card-publish-input::placeholder
    font-family: Muli
    font-size: 16px
    font-weight: 600
    color: #302f2f
    opacity: 0.4
.card-publish-input.disabled::placeholder
    opacity: 0.2
.card-publish-input-select
    position: relative
    display: inline-block
    width: 100%
    cursor: pointer
.card-publish-cat
    border-radius: 13px
    border: solid 1px #ffffff
    background-color: #d0d0d0
    display: inline-block
    padding: 4px 12px 4px 32px
    margin-right: 8px
    margin-bottom: 8px
    width: auto
    height: 18px
    font-family: Montserrat
    font-size: 14px
    line-height: 1.29
    text-align: center
    color: #ffffff
    position: relative
    cursor: pointer
.card-publish-cat .icon
    position: absolute
    top: 50%
    left: 12px
    transform: translateY(-50%)
    width: 16px
    height: 16px
.card-publish-cat.active
    background-color: $primary
.card-publish-datepicker
    position: relative
.card-publish-datepicker i.fa-calendar-alt
    position: absolute
    margin-top: 8px
    right: 4px
    color: $primary
    font-size: 16px
    font-weight: 100
    z-index: 200
.vdp-datepicker__calendar
    right: 0
.multiselect.publish-store-select
    border: 1px solid $primary
    width: 100%
.multiselect.publish-store-select:hover
    background-color: rgba(black, 0)
.publish-store-select .multiselect__placeholder
    color: #302f2f
    opacity: 0.4
.publish-store-select .multiselect__select:before
    border-color: transparent transparent #e94c2c #e94c2c
</style>